// i18n/locales/legal.js - Legal documents translations

export const legalTranslations = {
  it: {
    legal: {
      // Privacy Policy
      privacy: {
        title: "Privacy Policy",
        lastUpdated: "Ultimo aggiornamento: 18 ottobre 2025",
        contact: "Contatto privacy: betterpdp@gmail.com",
        
        section1: {
          title: "1. Introduzione",
          content: "La presente «Privacy Policy» (\"Policy\") descrive le modalità di raccolta, utilizzo, conservazione e protezione dei dati personali da parte di BetterPDP (P. IVA: TBD) (\"noi\", \"nostro\", \"BetterPDP\") in qualità di Titolare del trattamento. La presente Policy si applica: (i) al sito web www.betterpdp.com e alle sue sottopagine, (ii) all'applicativo SaaS da noi erogato, (iii) alle persone fisiche che accedono come \"guest\"/utente registrato ai nostri servizi (collettivamente, gli \"Utenti\"). Ci impegniamo a rispettare il Regolamento (UE) 2016/679 (\"GDPR\"), il California Consumer Privacy Act (\"CCPA\") e la Consumer Rights Directive dell'UE, nonché ogni altra normativa applicabile in materia di protezione dei dati."
        },
        
        section2: {
          title: "2. Definizioni",
          items: [
            "«Dati personali»: qualsiasi informazione riguardante una persona fisica identificata o identificabile.",
            "«Titolare del trattamento»: BetterPDP, che determina le finalità e i mezzi del trattamento dei Dati personali.",
            "«Responsabile del trattamento»: soggetto che tratta Dati per conto del Titolare, come da accordi contrattuali.",
            "«Utente»: la persona fisica che utilizza la piattaforma BetterPDP, sia nella modalità guest che registrata.",
            "«Crediti»: unità di utilizzo acquistabili (o concesse gratuitamente in modalità freemium) che consentono l'analisi di URL PDP."
          ]
        },
        
        section3: {
          title: "3. Titolare e sede del trattamento",
          content: "Questo sito è gestito da Federico De Micco, persona fisica. Il progetto BetterPDP è in fase di test e non costituisce attività economica abituale. Eventuali dati raccolti (es. email, feedback, analytics) sono trattati nel rispetto del GDPR esclusivamente a fini di miglioramento del prodotto. Per qualsiasi richiesta: betterpdp@gmail.com. ",        },
        
        section4: {
          title: "4. Quali dati vengono raccolti",
          intro: "Raccogliamo e trattiamo le seguenti categorie di dati personali e d'uso:",
          subsection1: {
            title: "4.1 Dati forniti dall'Utente",
            items: [
              "Nome e cognome (ove richiesto)",
              "Indirizzo email (ad es. registrazione, fatturazione)",
              "Credenziali di accesso (email/account e password)",
              "Dati di pagamento tramite il fornitore di servizi (\"Stripe\") – NB: i dati completi della carta non vengono conservati da noi, bensì gestiti da Stripe",
              "URL del PDP forniti per l'analisi",
              "Altri dati volontariamente forniti (es. risposte a form di contatto, customer support)"
            ]
          },
          subsection2: {
            title: "4.2 Dati raccolti automaticamente",
            items: [
              "Indirizzo IP, data e ora di accesso, browser e sistema operativo, identificatori del dispositivo",
              "Informazioni di utilizzo del servizio (quali URL analizzate, risultati generati, crediti consumati)",
              "Cookie e tecnologie simili (cfr. Cookie Policy) – incluso l'uso di Google Analytics 4 + Google Tag Manager",
              "Dati relativi all'interazione con email transazionali inviate tramite Resend"
            ]
          }
        },
        
        section5: {
          title: "5. Finalità e base giuridica del trattamento",
          intro: "Tramite i Dati, perseguiamo le seguenti finalità:",
          items: [
            "(a) Erogazione del servizio: registrazione, autenticazione, amministrazione dell'account, gestione crediti, acquisto pacchetti, comunicazioni transazionali => base giuridica: esecuzione di contratto o misure precontrattuali.",
            "(b) Miglioramento del servizio e analisi AI-ready: utilizzo dei dati (anonimizzati o pseudonimizzati) per affinare i modelli di suggerimento SEO/UX/AI => base giuridica: interesse legittimo del Titolare (garantire l'evoluzione della piattaforma) o consenso (ove richiesto).",
            "(c) Adempimenti legali e fiscali: conservazione dei dati per obblighi contabili/fiscali.",
            "(d) Marketing diretto (solo se espressamente acconsentito): invio di comunicazioni promozionali — non svolgiamo newsletter automatiche se non su esplicito consenso."
          ]
        },
        
        section6: {
          title: "6. Terze parti / trasferimento dei dati",
          intro: "Collaboriamo con i seguenti fornitori esterni, che possono trattare Dati personali in qualità di Responsabili del trattamento:",
          providers: [
            "Supabase (Database & Auth – infrastruttura PostgreSQL con sede UE)",
            "Stripe (Pagamenti – sede USA e UE)",
            "OpenAI API (Elaborazione modelli AI – sede USA)",
            "Resend (Email transazionali)",
            "Google Analytics 4 + Tag Manager (analisi comportamentale)"
          ],
          outro: "I dati personali possono essere trasferiti verso Paesi terzi (nel caso di OpenAI, Stripe, Google) — in tal caso abbiamo predisposto misure adeguate (ad esempio clausole contrattuali standard, ove applicabili) per garantire un livello di protezione equivalente a quello previsto dal GDPR."
        },
        
        section7: {
          title: "7. Durata della conservazione",
          intro: "Conserviamo i Dati personali per il tempo strettamente necessario in base alla finalità:",
          items: [
            "Conti gratuiti/non registrati: fino a 12 mesi dall'ultimo accesso, salvo obblighi contrattuali o legali.",
            "Utenti registrati/paganti: per l'intera durata dell'account + 10 anni per obblighi fiscali e contabili.",
            "Dati anonimi o pseudonimizzati per finalità di miglioramento algoritmo: fino alla cessazione dell'uso analitico, salvo necessità."
          ]
        },
        
        section8: {
          title: "8. Diritti degli interessati",
          intro: "In accordo al GDPR, gli Utenti hanno i seguenti diritti:",
          items: [
            "Accesso ai propri dati personali",
            "Rettifica o cancellazione (\"diritto all'oblio\")",
            "Limitazione del trattamento",
            "Portabilità dei dati",
            "Opposizione al trattamento basato su interesse legittimo",
            "Revoca del consenso in ogni momento (senza pregiudicare la liceità del trattamento antecedente)",
            "Presentare reclamo all'Autorità Garante per la protezione dei dati"
          ]
        },
        
        section9: {
          title: "9. Sicurezza dei dati",
          content: "Adottiamo misure tecniche e organizzative appropriate (es. cifratura dei dati, accessi autenticati, backup, gestione degli incidenti) per proteggere i Dati personali. Nonostante ciò, nessun sistema è completamente sicuro e BetterPDP non può garantire la totale sicurezza assoluta."
        },
        
        section10: {
          title: "10. Minorenni",
          content: "Il servizio non è rivolto a persone di età inferiore ai 16 anni. Non raccogliamo consapevolmente dati di minori. Se veniamo a conoscenza che un minore ha fornito Dati personali, provvederemo alla loro cancellazione."
        },
        
        section11: {
          title: "11. Modifiche alla Policy",
          content: "Ci riserviamo il diritto di modificare la presente Policy in qualsiasi momento. In caso di modifiche sostanziali, informeremo gli Utenti mediante avviso sul sito o via email. La versione aggiornata sarà pubblicata con nuova data \"Ultimo aggiornamento\"."
        },
        
        section12: {
          title: "12. Informativa CCPA (Utenti USA)",
          content: "Per gli Utenti residenti in California, la presente Policy contiene le informazioni richieste dal CCPA: diritto di accesso, cancellazione, non discriminazione, etc."
        },
        
        section13: {
          title: "13. Contatti",
          content: "Per domande relative alla presente Policy o per esercitare i propri diritti: betterpdp@gmail.com."
        }
      },
      
      // Terms of Service
      terms: {
        title: "Terms of Service",
        lastUpdated: "Ultimo aggiornamento: 18 ottobre 2025",
        
        section1: {
          title: "1. Accettazione dei Termini",
          content: "Le presenti Condizioni generali di servizio (\"Terms\") regolano l'accesso e l'uso da parte dell'utente (\"Utente\", \"tu\") della piattaforma SaaS BetterPDP (www.betterpdp.com) erogata da BetterPDP, con sede legale in Italia (P. IVA: TBD). Utilizzando o accedendo al servizio accetti integralmente questi Terms. Se non accetti, non puoi utilizzare il servizio."
        },
        
        section2: {
          title: "2. Descrizione del servizio",
          content: "BetterPDP è una piattaforma che consente l'analisi automatizzata di Product Detail Pages (PDP) per siti e-commerce e fornisce suggerimenti per l'ottimizzazione SEO, UX ed \"AI-readiness\".",
          modes: [
            "Modalità Guest: accesso gratuito e consumo di 1 URL di analisi senza registrazione o con registrazione limitata.",
            "Modalità Utente registrato: creazione di account, acquisto di pacchetti crediti (5, 10, 20) oppure Lifetime Access mediante pagamento tramite Stripe. Ogni analisi consuma 1 credito. Le analisi vengono salvate e collegate all'utente."
          ]
        },
        
        section3: {
          title: "3. Registrazione e crediti",
          items: [
            "Per passare da modalità guest a registrato occorre fornire email, password e accettare la Privacy Policy.",
            "I pacchetti crediti acquistati sono personali e non trasferibili.",
            "Il saldo crediti è visibile nel pannello utente e aggiornato in tempo reale.",
            "BetterPDP non garantisce che ogni URL porti a un suggerimento: la qualità dipende dalla pagina fornita."
          ]
        },
        
        section4: {
          title: "4. Pagamenti e rimborsi",
          items: [
            "I pagamenti sono gestiti da Stripe. I dati carta di credito non sono conservati da BetterPDP.",
            "I pacchetti acquistati non sono rimborsabili, salvo obblighi di legge o previo accordo scritto. In conformità alla Direttiva UE sui diritti dei consumatori, hai 14 giorni dall'acquisto per richiedere un rimborso completo per crediti non utilizzati.",
            "In caso di Lifetime Access, l'accesso è garantito fintantoché la piattaforma resti operativa; BetterPDP si riserva il diritto di modificare prezzi/piani per nuovi utenti."
          ]
        },
        
        section5: {
          title: "5. Licenza d'uso",
          items: [
            "BetterPDP concede all'Utente un diritto non esclusivo, non trasferibile, revocabile di accesso al servizio in conformità al presente contratto.",
            "L'Utente non può effettuare reverse engineering, decompilare, disassemblare, né tentare di estrarre l'algoritmo o i modelli AI proprietari.",
            "L'Utente non può utilizzare il servizio per scopi illeciti o contrari ai Terms, né condividere il proprio account con terzi."
          ]
        },
        
        section6: {
          title: "6. Contenuti dell'Utente e proprietà",
          items: [
            "L'Utente conserva tutti i diritti relativi agli URL e al contenuto inviato per analisi.",
            "BetterPDP acquisisce una licenza limitata per trattare tali contenuti al fine di generare suggerimenti.",
            "BetterPDP resta proprietaria della piattaforma, del codice, dei risultati generati e dei modelli AI, salvo diversa pattuizione."
          ]
        },
        
        section7: {
          title: "7. Responsabilità limitata e disclaimer AI",
          items: [
            "Le analisi e i suggerimenti forniti sono da intendersi indicativi e non costituiscono consulenza professionale garantita.",
            "BetterPDP declina ogni responsabilità per danni derivanti dall'uso o dall'interpretazione dei suggerimenti.",
            "L'Utente utilizza il servizio a proprio rischio.",
            "BetterPDP non garantisce che il servizio sia privo di errori, ininterrotto o sicuro."
          ]
        },
        
        section8: {
          title: "8. Sospensione e cancellazione dell'account",
          content: "BetterPDP si riserva il diritto di sospendere o cancellare un account in caso di violazione dei presenti Terms, attività illecite, mancato pagamento o uso dannoso della piattaforma. In caso di cancellazione, l'Utente perde accesso ai crediti residui e ai dati associati, salvo obblighi legali di conservazione."
        },
        
        section9: {
          title: "9. Modifiche al servizio e ai Terms",
          content: "BetterPDP può modificare il servizio, i piani crediti o i presente Terms in qualsiasi momento. Tali modifiche saranno comunicate via email o banner sul sito. L'uso continuo del servizio dopo la pubblicazione delle modifiche implica accettazione delle nuove condizioni."
        },
        
        section10: {
          title: "10. Diritti di proprietà intellettuale",
          content: "Tutti i diritti relativi al software, al marchio \"BetterPDP\", ai contenuti del sito e ai modelli AI sono di proprietà esclusiva di BetterPDP o dei suoi licenzianti. L'Utente si impegna a non copiare, riprodurre, distribuire o creare lavori derivati senza autorizzazione scritta."
        },
        
        section11: {
          title: "11. Legge applicabile e foro competente",
          content: "Le presenti Terms sono regolate dalla legge italiana e dalle disposizioni del Regolamento (UE) 2016/679. Per ogni controversia sarà competente in via esclusiva il Foro di Napoli o il Foro del luogo di residenza dell'Utente se ubicato in Italia."
        },
        
        section12: {
          title: "12. Clausole generali",
          content: "Se una qualsiasi disposizione dei presenti Terms è ritenuta invalida o inapplicabile, le restanti disposizioni resteranno in vigore. Nessuna omissione o ritardo nell'esercizio di un diritto costituisce rinuncia di tale diritto."
        },
        
        section13: {
          title: "13. Freemium e crediti",
          items: [
            "Il servizio in modalità freemium consente l'esecuzione di una (1) analisi gratuita per Utente non registrato o registrato ma non ancora sottoscritto.",
            "I pacchetti crediti acquistati NON hanno scadenza e possono essere utilizzati in qualsiasi momento.",
            "In caso di cessazione del servizio da parte di BetterPDP, le condizioni di rimborso o conversione dei crediti residui saranno comunicate tempestivamente."
          ]
        },
        
        section14: {
          title: "14. Privacy & trattamento dati",
          content: "L'utilizzo del servizio implica il trattamento dei Dati personali secondo quanto indicato nella Privacy Policy accessibile su /privacy. In particolare, l'Utente accetta che i dati di utilizzo possano essere utilizzati per finalità di miglioramento dei modelli AI e ottimizzazione della piattaforma."
        }
      },
      
      // Cookie Policy
      cookies: {
        title: "Cookie Policy",
        lastUpdated: "Ultimo aggiornamento: 18 ottobre 2025",
        
        section1: {
          title: "1. Introduzione",
          content: "Questo sito utilizza cookie e tecnologie simili (es. web beacons, local storage) per garantire il funzionamento, migliorare l'esperienza utente e misurare l'utilizzo. Ai sensi del Regolamento (EU) 2016/679 (GDPR) e della Direttiva ePrivacy, forniamo informazioni sul tipo di cookie utilizzati e richiediamo il consenso, ove necessario, tramite banner al primo accesso."
        },
        
        section2: {
          title: "2. Definizioni e precisazioni",
          items: [
            "«Cookie»: piccolo file di testo salvato sul terminale dell'Utente dal browser o dispositivo.",
            "«Cookie tecnici/essenziali»: necessari per il funzionamento del sito o servizio.",
            "«Cookie di profilazione/statistici»: utilizzati per analisi comportamentali, marketing, tracciamento.",
            "«Banner cookie»: strumento illustrativo all'accesso al sito per gestire il consenso."
          ]
        },
        
        section3: {
          title: "3. Gestione del consenso",
          content: "Al primo accesso, comparirà un banner che informa sull'uso dei cookie, consente all'Utente di accettare tutti, rifiutare tutti non-essenziali o personalizzare le preferenze. Il consenso è revocabile in qualsiasi momento tramite link \"Preferenze Cookie\" nel footer del sito."
        },
        
        section4: {
          title: "4. Tabella dei cookie",
          table: {
            headers: ["Nome cookie", "Tipo / Categoria", "Finalità", "Fornitore", "Durata"],
            rows: [
              ["session_id", "Tecnico/essenziale", "Mantenere sessione utente login", "BetterPDP", "sessione"],
              ["supabase_auth_token", "Tecnico/essenziale", "Autenticazione via Supabase", "Supabase", "fino a logout"],
              ["_ga / _ga_<container>", "Statistico", "Analytics – Google Analytics 4", "Google", "2 anni"],
              ["_gid", "Statistico", "Analytics – Google Analytics 4", "Google", "24 ore"],
              ["stripe_mid / stripe_*", "Tecnico/essenziale", "Pagamenti e gestione carrello – Stripe", "Stripe", "fino a 2 anni"],
              ["_gcl_au", "Statistico/marketing", "Conversioni Google Ads (se applicato)", "Google", "3 mesi"]
            ]
          }
        },
        
        section5: {
          title: "5. Descrizione delle categorie",
          items: [
            "Cookie tecnici/essenziali: indispensabili per l'erogazione del servizio (registrazione, login, pagamento, consumo crediti). Il loro consenso non è richiesto.",
            "Cookie statistici/analitici: utilizzati per capire come gli Utenti utilizzano la piattaforma, migliorare l'esperienza, misurare performance (es. Google Analytics 4). Il consenso è richiesto e può essere negato senza pregiudicare l'uso del servizio base.",
            "Cookie di marketing/profilazione: (es. conversioni pubblicitarie) – attualmente non utilizziamo cookie di profilazione esterna se non tramite fornitori esterni che richiedono consenso esplicito."
          ]
        },
        
        section6: {
          title: "6. Disabilitazione dei cookie",
          content: "L'Utente può modificare le impostazioni del browser per bloccare o cancellare i cookie continuamente. Tuttavia ciò potrebbe compromettere il corretto funzionamento di alcune parti del sito. Inoltre, è sempre possibile gestire le preferenze tramite il link \"Preferenze Cookie\"."
        },
        
        section7: {
          title: "7. Aggiornamenti alla Cookie Policy",
          content: "Potremo aggiornare la presente Cookie Policy in accordo con cambiamenti normativi o tecnici. L'ultima versione sarà pubblicata con \"Last updated\". In caso di modifiche rilevanti, verrà visualizzato un banner informativo o inviata email agli Utenti registrati."
        },
        
        section8: {
          title: "8. Contatti",
          content: "Per domande in merito all'uso dei cookie: betterpdp@gmail.com."
        }
      }
    },
    
    // Legal Checkbox translations
    legal_checkbox: {
      agree_to: "Accetto i",
      terms: "Termini di Servizio",
      and: "e la",
      privacy: "Privacy Policy",
      required: "Devi accettare i termini e la privacy policy per continuare"
    }
  },
  
  en: {
    legal: {
      // Privacy Policy
      privacy: {
        title: "Privacy Policy",
        lastUpdated: "Last updated: October 18, 2025",
        contact: "Privacy contact: betterpdp@gmail.com",
        
        section1: {
          title: "1. Introduction",
          content: "This Privacy Policy explains how BetterPDP, a business (VAT number: TBD) with registered office in Italy (\"we\", \"our\", \"BetterPDP\"), as Data Controller, collects, uses, stores and protects personal data of its users (\"Users\") through the website www.betterpdp.com and its SaaS service. It applies to both guest and registered users who access the service. We comply with the EU GDPR, California's CCPA, and the EU Consumer Rights Directive."
        },
        
        section2: {
          title: "2. Definitions",
          items: [
            "«Personal data»: any information relating to an identified or identifiable natural person.",
            "«Data Controller»: BetterPDP, which determines the purposes and means of processing Personal Data.",
            "«Data Processor»: an entity that processes Data on behalf of the Controller under contractual agreements.",
            "«User»: the natural person using the BetterPDP platform, either in guest or registered mode.",
            "«Credits»: purchasable usage units (or granted for free in freemium mode) that allow PDP URL analysis."
          ]
        },
        
        section3: {
          title: "3. Data Controller and location",
          content: "NOTICE: This website is operated by Federico De Micco, an individual. The BetterPDP project is in testing and does not constitute a habitual business activity. Any collected data (e.g., email, feedback, analytics) is processed under GDPR solely to improve the product. Contact: betterpdp@gmail.com."
        },
        
        section4: {
          title: "4. What data we collect",
          intro: "We collect and process the following categories of personal and usage data:",
          subsection1: {
            title: "4.1 Data you provide",
            items: [
              "Name and surname (where required)",
              "Email address (e.g., registration, billing)",
              "Login credentials (email/account and password)",
              "Payment data via service provider (\"Stripe\") – Note: full card details are not stored by us but managed by Stripe",
              "PDP URLs provided for analysis",
              "Other voluntarily provided data (e.g., contact form responses, customer support)"
            ]
          },
          subsection2: {
            title: "4.2 Data collected automatically",
            items: [
              "IP address, access date and time, browser and operating system, device identifiers",
              "Service usage information (URLs analyzed, results generated, credits consumed)",
              "Cookies and similar technologies (see Cookie Policy) – including use of Google Analytics 4 + Google Tag Manager",
              "Data related to interaction with transactional emails sent via Resend"
            ]
          }
        },
        
        section5: {
          title: "5. Purposes and legal basis",
          intro: "Through the Data, we pursue the following purposes:",
          items: [
            "(a) Service provision: registration, authentication, account administration, credit management, package purchases, transactional communications => legal basis: contract performance or pre-contractual measures.",
            "(b) Service improvement and AI-ready analysis: use of data (anonymized or pseudonymized) to refine SEO/UX/AI suggestion models => legal basis: legitimate interest of the Controller (ensuring platform evolution) or consent (where required).",
            "(c) Legal and fiscal compliance: data retention for accounting/fiscal obligations.",
            "(d) Direct marketing (only if expressly consented): sending promotional communications — we do not send automatic newsletters without explicit consent."
          ]
        },
        
        section6: {
          title: "6. Third parties / data transfers",
          intro: "We collaborate with the following external providers, who may process Personal Data as Data Processors:",
          providers: [
            "Supabase (Database & Auth – PostgreSQL infrastructure based in EU)",
            "Stripe (Payments – USA and EU based)",
            "OpenAI API (AI model processing – USA based)",
            "Resend (Transactional emails)",
            "Google Analytics 4 + Tag Manager (behavioral analysis)"
          ],
          outro: "Personal data may be transferred to third countries (in the case of OpenAI, Stripe, Google) — in such cases we have implemented adequate measures (e.g., standard contractual clauses, where applicable) to ensure a level of protection equivalent to that provided by GDPR."
        },
        
        section7: {
          title: "7. Retention periods",
          intro: "We retain Personal Data for the time strictly necessary based on the purpose:",
          items: [
            "Free/unregistered accounts: up to 12 months from last access, except for contractual or legal obligations.",
            "Registered/paying users: for the entire duration of the account + 10 years for fiscal and accounting obligations.",
            "Anonymous or pseudonymized data for algorithm improvement purposes: until analytical use ceases, except as necessary."
          ]
        },
        
        section8: {
          title: "8. Data subject rights",
          intro: "In accordance with GDPR, Users have the following rights:",
          items: [
            "Access to their personal data",
            "Rectification or deletion (\"right to be forgotten\")",
            "Restriction of processing",
            "Data portability",
            "Objection to processing based on legitimate interest",
            "Withdraw consent at any time (without prejudice to the lawfulness of prior processing)",
            "Lodge a complaint with the Data Protection Authority"
          ]
        },
        
        section9: {
          title: "9. Data security",
          content: "We adopt appropriate technical and organizational measures (e.g., data encryption, authenticated access, backups, incident management) to protect Personal Data. However, no system is completely secure and BetterPDP cannot guarantee absolute total security."
        },
        
        section10: {
          title: "10. Minors",
          content: "The service is not directed to persons under 16 years of age. We do not knowingly collect data from minors. If we become aware that a minor has provided Personal Data, we will proceed with its deletion."
        },
        
        section11: {
          title: "11. Changes to this Policy",
          content: "We reserve the right to modify this Policy at any time. In case of substantial changes, we will inform Users through notice on the site or via email. The updated version will be published with a new \"Last updated\" date."
        },
        
        section12: {
          title: "12. CCPA Disclosure (USA Users)",
          content: "For Users residing in California, this Policy contains the information required by CCPA: right of access, deletion, non-discrimination, etc."
        },
        
        section13: {
          title: "13. Contact",
          content: "For questions related to this Policy or to exercise your rights: betterpdp@gmail.com."
        }
      },
      
      // Terms of Service
      terms: {
        title: "Terms of Service",
        lastUpdated: "Last updated: October 18, 2025",
        
        section1: {
          title: "1. Acceptance of Terms",
          content: "These Terms of Service (\"Terms\") govern the access to and use of the SaaS platform BetterPDP (www.betterpdp.com) provided by BetterPDP, with registered office in Italy (VAT: TBD). By using or accessing the Service, you agree to be bound by these Terms. If you do not agree, you must not use the Service."
        },
        
        section2: {
          title: "2. Service description",
          content: "BetterPDP is a platform that automatically analyzes e-commerce Product Detail Pages (PDPs) and provides optimization suggestions for SEO, UX, and AI-readiness.",
          modes: [
            "Guest mode: One free analysis per user without registration.",
            "Registered user mode: Account creation, purchase of credit packages (5, 10, 20) or Lifetime Access through Stripe. Each analysis consumes 1 credit. Results are saved and linked to the user."
          ]
        },
        
        section3: {
          title: "3. Registration and credits",
          items: [
            "Registration requires an email, password, and acceptance of the Privacy Policy.",
            "Credits are personal and non-transferable.",
            "The current credit balance appears in the user dashboard.",
            "BetterPDP cannot guarantee that every URL will yield optimization results; quality depends on the source page."
          ]
        },
        
        section4: {
          title: "4. Payments and refunds",
          items: [
            "Payments are processed by Stripe. BetterPDP does not store full card details.",
            "Purchased packages are non-refundable except where required by law. In accordance with EU Consumer Rights Directive, you have 14 days from purchase to request a full refund for unused credits. After 14 days or if credits are consumed, no refund is available except as required by law.",
            "Lifetime Access remains valid as long as the platform is operational; BetterPDP may update pricing or plans for new Users."
          ]
        },
        
        section5: {
          title: "5. License of use",
          items: [
            "BetterPDP grants the User a non-exclusive, non-transferable, revocable license to use the Service under these Terms.",
            "You may not reverse engineer, decompile, disassemble, or attempt to extract algorithms or AI models.",
            "You agree not to use the Service for unlawful purposes or share your account with third parties."
          ]
        },
        
        section6: {
          title: "6. User content and ownership",
          items: [
            "You retain ownership of URLs and content submitted for analysis.",
            "BetterPDP obtains a limited license to process that content solely to generate suggestions.",
            "BetterPDP owns all rights to the platform, generated results, and AI models unless otherwise agreed."
          ]
        },
        
        section7: {
          title: "7. Limitation of liability and AI disclaimer",
          items: [
            "The analyses and recommendations are indicative only and do not constitute professional advice.",
            "BetterPDP shall not be liable for damages arising from the use or interpretation of such results.",
            "Use of the Service is at your own risk.",
            "BetterPDP does not guarantee uninterrupted, error-free, or fully secure operation."
          ]
        },
        
        section8: {
          title: "8. Account suspension and termination",
          content: "BetterPDP may suspend or terminate any account that violates these Terms, engages in unlawful activity, fails to pay, or misuses the Service. Upon termination, you lose access to remaining credits and stored data, except where retention is legally required."
        },
        
        section9: {
          title: "9. Service changes and updates",
          content: "BetterPDP may modify the Service, credit plans, or these Terms at any time. Material changes will be communicated via email or banner notice. Continued use implies acceptance."
        },
        
        section10: {
          title: "10. Intellectual property",
          content: "All software, trademarks, site content, and AI models remain the exclusive property of BetterPDP or its licensors. Users may not copy, reproduce, distribute, or create derivative works without written authorization."
        },
        
        section11: {
          title: "11. Governing law and jurisdiction",
          content: "These Terms are governed by Italian law and applicable EU regulations (including GDPR). Disputes will fall under the jurisdiction of the Court of Naples or the User's place of residence if in Italy."
        },
        
        section12: {
          title: "12. General clauses",
          content: "If any clause of these Terms is held invalid or unenforceable, the remainder shall continue in full force. No delay or omission in exercising a right constitutes a waiver of that right."
        },
        
        section13: {
          title: "13. Freemium and credits clause",
          items: [
            "The freemium plan allows one (1) free analysis per guest or non-subscribed user.",
            "Purchased credits have NO expiration date and can be used at any time.",
            "If the Service ceases, BetterPDP will communicate refund or conversion options for remaining credits."
          ]
        },
        
        section14: {
          title: "14. Privacy and data processing",
          content: "Use of the Service implies data processing in accordance with our Privacy Policy. You agree that usage data may be used to improve AI models and service performance."
        }
      },
      
      // Cookie Policy
      cookies: {
        title: "Cookie Policy",
        lastUpdated: "Last updated: October 18, 2025",
        
        section1: {
          title: "1. Introduction",
          content: "This website uses cookies and similar technologies (e.g., web beacons, local storage) to ensure proper operation, enhance user experience, and measure traffic. In compliance with Regulation (EU) 2016/679 (GDPR) and the ePrivacy Directive, this Policy provides information on the types of cookies used and explains how consent is obtained through the cookie banner."
        },
        
        section2: {
          title: "2. Definitions and key terms",
          items: [
            "«Cookie»: a small text file saved on the user's device by the browser.",
            "«Technical / essential cookies»: necessary for the functioning of the site or service.",
            "«Analytics / profiling cookies»: used for behavioural analysis, marketing, and audience measurement.",
            "«Cookie banner»: the notice displayed on first access that allows users to manage consent preferences."
          ]
        },
        
        section3: {
          title: "3. Consent management",
          content: "Upon the first visit, a cookie banner appears informing the user about cookie use and offering options to \"Accept All\", \"Reject All Non-Essential\" or \"Customize Preferences\". Consent can be withdrawn at any time via the \"Cookie Preferences\" link in the website footer."
        },
        
        section4: {
          title: "4. Cookie table",
          table: {
            headers: ["Cookie name", "Type / Category", "Purpose", "Provider", "Duration"],
            rows: [
              ["session_id", "Technical / essential", "Maintains login session", "BetterPDP", "session"],
              ["supabase_auth_token", "Technical / essential", "Authentication via Supabase", "Supabase", "until logout"],
              ["_ga, _ga_<container>", "Analytics", "Google Analytics 4 traffic stats", "Google", "2 years"],
              ["_gid", "Analytics", "Daily session stats (GA4)", "Google", "24 hours"],
              ["stripe_mid, stripe_*", "Technical / essential", "Payment processing (Stripe)", "Stripe", "up to 2 years"],
              ["_gcl_au", "Analytics / marketing", "Google Ads conversion tracking", "Google", "3 months"]
            ]
          }
        },
        
        section5: {
          title: "5. Cookie categories explained",
          items: [
            "Technical / essential cookies – strictly required for login, checkout, or credit management. Consent not required.",
            "Analytics cookies – help us understand how users interact with the platform and improve its performance (e.g., GA4). Consent is required and can be freely denied.",
            "Marketing / profiling cookies – used for advertising or conversion measurement. BetterPDP currently does not use external profiling cookies except those explicitly consented to through providers."
          ]
        },
        
        section6: {
          title: "6. How to disable cookies",
          content: "Users can modify browser settings at any time to block or delete cookies, though doing so may impact some site functionalities. Preferences can also be managed directly via the \"Cookie Preferences\" link."
        },
        
        section7: {
          title: "7. Updates to this Policy",
          content: "We may update this Cookie Policy following legal or technical changes. The latest version will always show the \"Last updated\" date. Significant updates will be announced via a banner or email to registered Users."
        },
        
        section8: {
          title: "8. Contact",
          content: "For questions regarding our cookie use, contact: betterpdp@gmail.com."
        }
      }
    }
  }
};

export default legalTranslations;
